module.exports = __webpack_public_path__ + "static/media/disc_1.1caf4dd9.png";